export const style = {
  inputStyle: {
    marginBottom: 1,
    position: "relative",
    width: "100%",
  },

  inputStyle2: {
    padding: 0,
  },

  datepickerStyle: {
    marginBottom: 1,
    position: "relative",
    width: "100%",
    height: "33px",
    //display: "contents",
  },

  linkStyle: {
    textDecoration: "none !important",
    color: "#0072C6 !important",
    fontWeight: "normal !important",
    fontSize: "12px !important",
    textDecorationLine: "underline !important",
    cursor: "pointer !important",
    "&:hover": {
      color: "#ffad30 !important",
      fontWeight: "normal !important",
      textDecorationLine: "underline !important",
    },
  },

  interactiveLinkButton: {
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: "6px",
    fontSize: "12px",
    color: "#0072C6",
    textDecoration: "underline",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#e6f2fb",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      color: "#005a99",
    },

    "&:active": {
      transform: "scale(0.97)",
    },
  },

  textareaAutosizeStyle: {
    marginBottom: 1,
    //position: "relative",
    width: "100%",
    font: "caption",
    color: "#495057",
    fontSize: "14px",
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
  },

  gridStyle: {
    marginBottom: 1,
  },

  dialogInputStyle: {
    position: "relative",
    width: "100%",
    marginBottom: 1,
  },

  buttonStyle: {
    backgroundColor: "#4b8cce",
    color: "#ffffff",
    height: 30,
    width: "auto",
    float: "right",
    margin: 1,
  },

  buttonStyleLeft: {
    backgroundColor: "#1a73e8",
    color: "#ffffff",
    height: 30,
    width: "auto",
    float: "left",
    margin: 5,
  },

  dialogButtonStyle: {
    backgroundColor: "#1a73e8",
    color: "#ffffff",
    height: 30,
    width: "auto",
    float: "right",
    margin: 3,
  },

  dialogButtonStyleIpAuth: {
    backgroundColor: "#1a73e8",
    color: "#ffffff",
    height: 20,
    width: "80px",
    float: "right",
    margin: 3,
  },

  dialogButtonStyleLeft: {
    backgroundColor: "#1a73e8",
    color: "#ffffff",
    height: 30,
    width: "auto",
    float: "left",
    margin: 3,
  },

  dialogButtonStyleRight: {
    backgroundColor: "#1a73e8",
    color: "#ffffff",
    height: 30,
    width: "auto",
    float: "right",
    margin: 3,
  },

  dialogButtonStyleLeftCreditInfo: {
    backgroundColor: "#1a73e8",
    color: "#ffffff",
    height: 30,
    width: 300,
    float: "left",
    margin: 3,
  },

  dialogButtonStyleLeftContactInfo: {
    backgroundColor: "#1a73e8",
    color: "#ffffff",
    height: 30,
    width: "150px",
    float: "left",
    margin: 3,
  },

  ".MuiBox-root": {
    padding: "0px",
  },

  addButtonStyle: {
    backgroundColor: "#4CAF50",
    color: "#ffffff",
    height: 30,
    width: "auto",
    float: "left",
    margin: 1,
  },
  addUserManagementButtonStyle: {
    backgroundColor: "green",
    color: "#ffffff",
    height: 30,
    width: "auto",
    float: "left",
    margin: 1,
  },

  yellowButtonStyle: {
    backgroundColor: "#ff9900",
    color: "#ffffff",
    height: 20,
    width: 200,
  },

  iysLoadCreditButtonStyle: {
    backgroundColor: "#43a047",
    color: "white",
    height: 30,
    width: 150,
    margin: 3,
    float: "right",
  },

  spendingCreditButtonStyle: {
    backgroundColor: "#e53935",
    color: "white",
    height: 30,
    width: 150,
    margin: 3,
    float: "right",
  },

  grayButtonStyle: {
    backgroundColor: "#efefef",
    color: "#222",
    height: 20,
    width: 200,
    border: "1px solid black",
  },

  userInfoUpdateButtonStyle: {
    backgroundColor: "#c0c0c0",
    color: "#333333",
    height: 10,
    width: "40px",
    fontSize: "10px",
  },

  textAreaStyle: {
    position: "relative",
    width: "100%",
  },

  dialogTextAreaStyle: {
    position: "relative",
    width: "100%",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },

  addIconStyle: {
    margin: 10,
  },

  addCustomerStyle: {
    backgroundColor: "#ced8d8",
    color: "#394343",
    height: 40,
    width: 50,
    float: "left",
    margin: 2,
  },

  showCustomerHistoryStyle: {
    backgroundColor: " #2f4f4f",
    color: "#f4e92d",
    height: 40,
    width: 300,
  },

  gridLabelStyle: {
    textAlign: "left"
  },

  gridTextStyle: {
    overflowWrap: "anywhere !important"
  }


};

export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: "#9e9e9e",
    minHeight: "30px",
    height: "33px",
    boxShadow: state.isFocused ? null : null,
    fontSize: "12px",
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "33px",
    padding: "0 6px",
    fontSize: "12px",
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
    fontSize: "12px",
  }),
  indicatorSeparator: state => ({
    display: "none",
    fontSize: "12px",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "33px",
    fontSize: "12px",
  }),
  menuPortal: base => ({ ...base, zIndex: 10120, fontSize: "12px" }),
};

export const multiSelectStyles = {
  menuPortal: (base) => ({
    ...base,
    fontSize: '14px',
    fontWeight: '500'
  }),
  zIndex: 9999,
  input: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    fontWeight: '500',
  }),
  valueContainer: (provided, state) => ({
    fontSize: "14px",
    fontWeight: '500',
    padding: "0px 6px",
    width: '90%',
    height: '80px',
    overflowY: 'scroll',
  }),
};
